import { AskYourQuestion, GetExpertAns } from '../AskNowSection/styled';
import { PostedInImage, PostedInStyled } from './styled';

export default function PostedIn(props) {
  const { tagData } = props;
  return (
    <PostedInStyled>
      <PostedInImage src={tagData?.image} loading="lazy" alt="" />
      <div>
        <GetExpertAns>Posted In</GetExpertAns>
        <AskYourQuestion>{tagData?.description}</AskYourQuestion>
        <GetExpertAns>{tagData?.contentCount} Posts</GetExpertAns>
      </div>
    </PostedInStyled>
  );
}
